import React, { useState, useRef, useEffect } from "react";

const Dropdown = ({
  label,
  options = [],
  value,
  onChange,
  placeholder = "Select option",
  labelKey = "label",
  valueKey = "value",
  error,
  disabled = false,
  className = "",
  isRequired = false,
  selectClassName = "",
  showSearch,
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef();

  // Close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (!dropdownRef.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

const selectedItem = options?.find(
  (opt) =>
    String(opt[valueKey]).toLowerCase() ===
    String(value).toLowerCase()
);

  const filtered = options?.filter((opt) =>
    opt[labelKey]?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className={`relative w-full ${className}`} ref={dropdownRef}>
      {label && (
        <label className="text-xs font-medium text-gray-700 mb-1 block">
          {label} {isRequired && <span className="text-red-500">*</span>}
        </label>
      )}

      {/* Trigger */}
      <div
        onClick={() => !disabled && setOpen(!open)}
        className={`h-[36px] flex items-center justify-between px-3 rounded-md border transition-all focus:ring-1 focus:ring-[#FF6600] focus:outline-none
          ${disabled ? "bg-[#e9ecef] cursor-not-allowed" : "bg-white hover:border-gray-300 cursor-pointer"}
          ${error ? "border-red-400" : "border-gray-300"}
           ${selectClassName}`}
      >
        <span className="text-sm text-gray-700">
          {selectedItem ? selectedItem[labelKey] : placeholder}
        </span>
        <span className="text-xs text-gray-400">{open ? "▲" : "▼"}</span>
      </div>

      {/* Error */}
      {error && (
        <p className="text-xs text-red-500 mt-1">{error}</p>
      )}

      {/* Dropdown */}
      {open && (
        <div className="absolute z-50 mt-2 w-full bg-white border rounded-xl shadow-xl overflow-hidden animate-fadeIn">
          {/* Search */}
          {(showSearch !== undefined ? showSearch : options?.length > 5) && (
          <div className="p-2 border-b bg-gray-50">
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full px-3 py-2 text-sm border rounded-lg outline-none focus:border-blue-400"
            />
          </div>
          )}

          {/* List */}
          <ul className="max-h-52 overflow-y-auto">
            {filtered?.length === 0 && (
              <li className="p-3 text-center text-gray-400 text-sm">
                No data found
              </li>
            )}

            {filtered?.map((item, index) => (
              <li
                key={item[valueKey] ? `${item[valueKey]}-${index}` : index}
                onClick={() => {
                  onChange(item);
                  setOpen(false);
                  setSearch("");
                }}
                className="px-4 py-2 text-sm cursor-pointer hover:bg-blue-50 transition-colors"
              >
                {item[labelKey]}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Dropdown;